import {TOperator} from '@edna/utils';

import {EPermission, ERoles} from 'src/containers/User';

enum ECacheTag {
  USER = 'USER',
  TENANT = 'TENANT',
  FLOW_STEPS = 'FLOW_STEPS',
  FLOW = 'FLOW',
  CHANNELS = 'CHANNELS',
  SYSTEM_CALLBACK = 'SYSTEM_CALLBACK',
  NOTIFICATIONS = 'NOTIFICATIONS',
  NOTIFICATIONS_COUNT = 'NOTIFICATIONS_COUNT',
  CASCADES = 'CASCADES',
  BALANCE = 'BALANCE',
  PARAMETERS = 'PARAMETERS',
  TRANSACTIONS = 'TRANSACTIONS',
  SUPPORT_CLIENTS = 'SUPPORT_CLIENTS',
  LEAD_CLIENTS = 'LEAD_CLIENTS',
  OVERDRAFT = 'OVERDRAFT',
  COMPANY_DOCUMENT = 'COMPANY_DOCUMENT',
  TAGS = 'TAGS',
  SMS_CHANNEL = 'SMS_CHANNEL',
  SMS_SUBSCRIPTIONS = 'SMS_SUBSCRIPTIONS',
  WHATSAPP_CHANNEL = 'WHATSAPP_CHANNEL',
  PUSH_APPS = 'PUSH_APPS',
  BROADCASTS = 'BROADCASTS',
  AUTOPAYMENT = 'AUTOPAYMENT',
  ONETIME_PAYMENT = 'ONETIME_PAYMENT',
  MESSAGE_MATCHERS = 'MESSAGE_MATCHERS',
  MESSAGE_MATCHERS_LIST = 'MESSAGE_MATCHERS_LIST',
  SUBSCRIBERS = 'SUBSCRIBERS',
  TARIFFS = 'TARIFFS',
  TARIFFS_DETAILS = 'TARIFFS_DETAILS',
  TARIFFS_PRICING_DETAILS = 'TARIFFS_PRICING_DETAILS',
  TARIFFS_AVAILABLE = 'TARIFFS_AVAILABLE',
  TARIFFS_CONNECTED = 'TARIFFS_CONNECTED',
  LICENSES = 'LICENSES',
  SOLUTION_ID = 'SOLUTION_ID',
  MESSAGE_REPORT_GENERATIONS = 'MESSAGE_REPORT_GENERATIONS',
  FLOW_MESSAGE_REPORT_GENERATIONS = 'FLOW_MESSAGE_REPORT_GENERATIONS',
  API_KEY = 'API_KEY',
  CALLBACK = 'CALLBACK',
  AUTH_CALLBACK = 'AUTH_CALLBACK',
  MAILINGS = 'MAILINGS',
  SUBJECTS = 'SUBJECTS',
  AGENT_REPORTS = 'AGENT_REPORTS',
  COMPANY_USERS = 'COMPANY_USERS',
  CHANNEL_VERIFICATION = 'CHANNEL_VERIFICATION',
  SUBJECT_MIGRATIONS = 'SUBJECT_MIGRATIONS',
  DIALOGS = 'DIALOGS',
  DIALOG_MESSAGES = 'DIALOG_MESSAGES',
  ONBOARDING_SURVEY = 'ONBOARDING_SURVEY',
}

enum EFixedCacheKey {
  SIGN_IN = 'SIGN_IN',
  CREATE_PARAMETER = 'CREATE_PARAMETER',
  SUBSCRIBER_TAGS = 'SUBSCRIBER_TAGS',
  MESSAGE_MATCHER_UNIQUE_NAME = 'MESSAGE_MATCHER_UNIQUE_NAME',
  URL_UPLOAD = 'URL_UPLOAD',
  LEAD_UNIQUE_FIELD = 'LEAD_UNIQUE_FIELD',
}

const CACHE_LIFETIME = 5;

type THeaders = Record<string, string>;
type TMeta = Partial<{
  isShowError: boolean;
  errorMessageKey: string;
  i18nOptions: TAnyObject;
  isShowSuccess: boolean;
  successMessageKey: string;
  isBackendError: boolean;
  permissions: TOperator<EPermission>;
  roles: TOperator<ERoles>;
  headers: THeaders;
}> &
  TAnyObject;
type TActionMeta = {
  baseQueryMeta: TMeta;
};

const RESERVED_META_KEYS = ['isBackendError', 'headers'];

const REFRESH_API_URL = '/rest/auth/refresh';
const NON_CRITICAL_API_ENDPOINTS = [
  '/web-notification/change-status',
  '/web-notification/poll-all',
  '/web-notification/count',
  '/web-notification/mark-all-as-read',
].map((url) => `/rest${url}`);

enum EInternalError {
  ABORT_ERROR = 0,
  NETWORK_ERROR = 'networkError',
}

const unavailableStatusSet = new Set([502, 503, 504]);

export {
  ECacheTag,
  EFixedCacheKey,
  CACHE_LIFETIME,
  RESERVED_META_KEYS,
  REFRESH_API_URL,
  NON_CRITICAL_API_ENDPOINTS,
  EInternalError,
  unavailableStatusSet,
};
export type {THeaders, TMeta, TActionMeta};
